const config = {
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api/v1',
    SOCKET_URL: process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001'
};

export default config;